import { render, staticRenderFns } from "./b-date.vue?vue&type=template&id=54e4e820&scoped=true"
import script from "./b-date.vue?vue&type=script&lang=ts"
export * from "./b-date.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e4e820",
  null
  
)

export default component.exports